import React, { useMemo } from 'react'
import { injectIntl } from 'react-intl'
import { getFormattedDate, getDateFormat, getTimeFormat } from 'helpers/dates'
import { TYPE_INPUT_DATE_TIME, TYPE_INPUT_DATE } from 'helpers/jobs'
import { connect } from 'react-redux'
import { PreviewInputValuesProps } from './PreviewInputValues.types'
import {
  PreviewWrapper,
  PreviewItem,
  PreviewValueText,
} from './PreviewInputValues.styles'

const PreviewInputValues = ({
  previewInputs,
  licensee,
}: PreviewInputValuesProps) => {
  const { usaDateFormat, usaTimeFormat } = licensee
  const dateDisplay = useMemo(() => getDateFormat(usaDateFormat), [
    usaDateFormat,
  ])
  const timeDisplay = useMemo(
    () => getTimeFormat(usaTimeFormat).replace(/\s+/g, ''),
    [usaTimeFormat],
  )
  const renderPreviewValue = (value: string, type: string) => {
    if (type === TYPE_INPUT_DATE_TIME) {
      return getFormattedDate(value, `${dateDisplay} ${timeDisplay}`)
        .toString()
        .substring(0, 16)
    }

    if (type === TYPE_INPUT_DATE) {
      return getFormattedDate(value, dateDisplay).toString()
    }

    if (value === null) {
      return ''
    }

    return value.toString()
  }

  if (!previewInputs?.length) {
    return null
  }

  return (
    <PreviewWrapper>
      {previewInputs.map(({ title, short_name, value, type }) => (
        <PreviewItem key={title}>
          <span>{short_name || title}: </span>
          <PreviewValueText>{renderPreviewValue(value, type)}</PreviewValueText>
        </PreviewItem>
      ))}
    </PreviewWrapper>
  )
}

export default connect(
  (state: {
    getIn: (
      path: Array<string>,
    ) => {
      usaDateFormat: boolean
      usaTimeFormat: boolean
    }
  }) => ({
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
)(injectIntl(PreviewInputValues))
